module.exports = __webpack_public_path__ + "img/white.ea05ae65.png";